import styled from 'styled-components';

export const TagListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const TagTitle = styled.p`
  font-size: 14px;
  font-weight: bold;
  display: inline-block;
  align-self: center;
  margin: 0;
  margin-right: 8px;
`;

export const TagThemeBullet = styled.span`
  display: inline-block;
  align-self: center;
`;
